import React from 'react'
import Logo2 from '../image/Logo2.png'
import '../css/SectionDivider.css'

const SectionDivider = ({ dark = false }) => {
    return (

        <section className={`section-divider-wrapper ${dark ? 'dark' : ''}`}>

            {/* LINEA SUPERIOR */}
            <div className='divider-top-line'></div>

            {/* ORBITAS */}
            <div className='divider-orbit orbit-1'></div>
            <div className='divider-orbit orbit-2'></div>
            <div className='divider-orbit orbit-3'></div>

            {/* PARTICULAS */}
            <span className='divider-particle particle-1'></span>
            <span className='divider-particle particle-2'></span>
            <span className='divider-particle particle-3'></span>
            <span className='divider-particle particle-4'></span>

            {/* CONTENIDO */}
            <div className='divider-content'>

                {/* LINEA */}
                <div className='divider-side left'></div>

                {/* LOGO CENTER */}
                <div className='divider-center'>

                    {/* RINGS */}
                    <div className='ring ring-1'></div>
                    <div className='ring ring-2'></div>

                    {/* GLASS CARD */}
                    <div className='divider-glass'>

                        <div className='divider-light'></div>

                        <img
                            src={Logo2}
                            alt='ICS'
                            className='divider-logo'
                        />

                    </div>

                </div>

                {/* LINEA */}
                <div className='divider-side right'></div>

            </div>

            {/* TEXTO */}
            <div className='divider-label'>

                <span></span>

                <p>
                    Tecnología que impulsa negocios
                </p>

                <span></span>

            </div>

        </section>

    )
}

export default SectionDivider